import React from 'react';
import CountUp from 'react-countup';
import { NavLink } from 'react-router-dom';
import ReactPlayer from 'react-player';

var img1 = require('./../../images/video-bg.jpg');

class OurValue extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };

    render() {
        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b30 bg-white">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-md-4 col-sm-12">
                                    <div className="section-head">
                                        <div className="mt-separator-outer separator-left">
                                            <div className="mt-separator">
                                                <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'bold' }}>قــــيمنا</span> </h2>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className=" p-t150">
                                        <div className="author-signature">
                                            <img src={require('./../../images/gallery/portrait/worker.png')} alt="Signature" width={2000} height={150} />
                                        </div>
                                      
                                    </div>
                                 
                                </div>
                                <div className="col-md-4 col-sm-6">
                                    <div className="mt-count m-b30 text-white mt-icon-box-wraper center  bg-dark p-a40">
                                        <div className="counter font-30 font-weight-800 m-b15 text-primary" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'bold' }}>الاستدامة</div>
                                        <h4 className="m-tb0" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '15px', fontWeight: 'light' }}>
                                        نلتزم بتحقيق مستقبل مستدام كوننا مؤسسة رائدة مسؤولة ، حيث نسعى دائمًا لنكون نموذجًا يُحتذى به من خلال الالتزام بأعلى المعايير</h4>
                                    </div>
                                    <div className="mt-count m-b30 text-white mt-icon-box-wraper center  bg-dark p-a40">
                                    <div className="counter font-30 font-weight-800 m-b15 text-primary" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'bold' }}>المصداقية</div>
                                    <h4 className="m-tb0" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '15px', fontWeight: 'light' }}>
                                    نضمن جميع الأعمال المتعاقد عليها للعملاء ونطلعهم على خطوط سير العمل ضمن جدول زمني محدد وواضح قبل البدء في تنفيذ المشروع

                                    </h4>
                                    </div>
                                    <div className="mt-count m-b30 text-white mt-icon-box-wraper center  bg-dark p-a40">
                                    <div className="counter font-30 font-weight-800 m-b15 text-primary" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'bold' }}>الالتزام</div>
                                    <h4 className="m-tb0" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '15px', fontWeight: 'light' }}>
                                    نلتزم بأداء العمل وفق البيانات والمعطيات المقدمة من العملاء وتنفيذها حسب الضوابط والاحكام والاشتراطات الفنية وإنجازها بجودة عالية وآمنة

                                    عايير</h4>
                                    </div>
                                    
                                </div>
                                <div className="col-md-4 col-sm-6">
                                <div className="mt-count m-b30 text-white mt-icon-box-wraper center  bg-dark p-a40">
                                <div className="counter font-30 font-weight-800 m-b15 text-primary" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'bold' }}>الابتكار</div>
                                    <h4 className="m-tb0" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '15px', fontWeight: 'light' }}>
                                    نوظّف الابتكار كمحور أساسي في منهجية عملنا سواء على مستوى المنتجات أو إجراءات العمل.

                                    </h4>
                                    </div>
                                    <div className="mt-count m-b30 text-white mt-icon-box-wraper center  bg-dark p-a40">
                                    <div className="counter font-30 font-weight-800 m-b15 text-primary" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'bold' }}>الثقة</div>
                                    <h4 className="m-tb0" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '15px', fontWeight: 'light' }}>
                                    مبادئنا الأساسية ترتكز على النزاهة والتواصل بشفافية ومصداقية وساعين دوماً لمصالح عملاءنا

                                    عايير</h4>
                                    </div>
                                    <div className="mt-count m-b30 text-white mt-icon-box-wraper center  bg-dark p-a40">
                                    <div className="counter font-30 font-weight-800 m-b15 text-primary" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'bold' }}>الاتقان</div>
                                    <h4 className="m-tb0" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '15px', fontWeight: 'light' }}>
                                    نسعى جاهدين للعمل بأفضل الخدمات والأدوات النوعية، مُتحرين الإتقان في جميع أعمالنا

                                    عايير</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="myModal2" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <ReactPlayer url='https://vimeo.com/34741214' />
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurValue;